import type { FetchArgs } from '@reduxjs/toolkit/query';

export const AUTH_BOOTSTRAP_REQUEST_TIMEOUT_MS = 15_000;

export const applyAuthBootstrapRequestTimeout = (args: string | FetchArgs): string | FetchArgs => {
  const url = typeof args === 'string' ? args : args.url;
  if (url !== '/auth/user' && url !== '/users/permissions') return args;

  return {
    ...(typeof args === 'string' ? { url: args } : args),
    timeout:
      typeof args === 'string'
        ? AUTH_BOOTSTRAP_REQUEST_TIMEOUT_MS
        : (args.timeout ?? AUTH_BOOTSTRAP_REQUEST_TIMEOUT_MS),
  };
};
